export const listAccessionsByCity = async uuid => {
  return await window.$vue.$get({
    endpoint: `/plan/accession/city/${uuid}`
  })
}

//alterar
export const listSaleOrigins = async params => {
  return await window.$vue.$get({
    endpoint: "/sale/list-sale-origin/",
    params
  })
}

export const fetchDueDays = async headers => {
  return await window.$vue.$get({ endpoint: "/bank/due-days", headers })
}

export const fetchContractTypes = async params => {
  return await window.$vue.$get({ endpoint: "/sale/contract-types", params })
}

export const fetchAccessionByCity = async params => {
  return await window.$vue.$get({ endpoint: "/provider/accession", params })
}

export const listClientContracts = async document => {
  return await window.$vue.$get({
    endpoint: `/sale/list-active-contracts/${document}`,
  })
}

export const fetchPaymentType = async params => {
  return await window.$vue.$get({ endpoint: "/bank/payment-type", params })
}

export const fetchShippingMethod = async params => {
  return await window.$vue.$get({ endpoint: "/bank/shipping-method", params })
}

export const listServiceOrigin = async () => {
  return await window.$vue.$get({
    endpoint: "/sale/list-service-origin"
  })
}
